module.exports = __webpack_public_path__ + "img/report-red.e8648f29.svg";